import { t } from 'i18next';
import { notifications } from './toastNotifications';
import { extractApiErrorMessage, isValidationError } from './errorMessage';

export function handleApiError(e: unknown) {
  // Check if it's a validation error array
  if (isValidationError(e)) {
    e.forEach((err) => {
      if (err.message) {
        notifications.error(err.message);
      }
    });
  } else {
    // Extract user-friendly message from error
    const errorMessage = extractApiErrorMessage(e, { fallback: 'An error occurred' });
    notifications.error(t('f-logs-error', { error: errorMessage }));
  }
}
